import { render, staticRenderFns } from "./whatsapp-floating-button.vue?vue&type=template&id=4eb7965c&scoped=true"
import script from "./whatsapp-floating-button.vue?vue&type=script&lang=js"
export * from "./whatsapp-floating-button.vue?vue&type=script&lang=js"
import style0 from "./whatsapp-floating-button.vue?vue&type=style&index=0&id=4eb7965c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7965c",
  null
  
)

export default component.exports